import React from "react";
import { Link } from "react-router-dom";
import * as api from "../lib/api";
import { isNotNullOrEmpty } from "../lib/utilities";

const BookList = ({ items }) => {
  const sortedItems = api.sortByPubDate(items);

  const getOverlay = (item) => {
    const today = new Date();
    if (new Date(item.pubDate) > today) {
      const imgtype = isNotNullOrEmpty(item.amazonId)
        ? "preorder"
        : "comingsoon";
      return (
        <img
          alt={`${imgtype} ${item.title}`}
          className="book-ribbon"
          src={`/assets/misc/${imgtype}.png`}
        />
      );
    }

    return undefined;
  };

  return (
    <div className="row">
      {sortedItems.map((item) => (
        <div className="col" key={item.id}>
          <Link to={`/book/${item.id}`}>
            <div className="book-frame">
              <img
                alt={item.title}
                className="book"
                src={`/assets/books/${item.id}.jpg`}
              />
              {getOverlay(item)}
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default BookList;
